import Vue from "vue";
import dialogBoxComponent from "./DialogBox.vue";
import startScreenComponent from "./hok/StartScreen2";
import confirmScreenComponent from "./hok/ConfirmExit";
import defaultIframe from "../defaultIframe/defaultIframe.vue";
import loadingBoxComponent from "./LoadingBox.vue";

let dialogBox = (options = {}) => {
  let msgBoxConstructor = Vue.extend(dialogBoxComponent);
  let instance = new msgBoxConstructor({
    el: document.createElement("div"),
  });
  document.body.appendChild(instance.$el);
  // 将单个 confirm instance 的配置合并到默认值中
  Object.assign(instance.$data, options);
  return new Promise((resolve, reject) => {
    instance.visible = true;
    let confirm = instance.confirmFunc;
    let cancel = instance.cancelFunc;
    instance.confirmFunc = () => {
      resolve("confirm");
      confirm();
    };
    instance.cancelFunc = () => {
      resolve("cancel");
      cancel();
    };
  });
};

let hokStartScreen = (options = {}) => {
  let constructor = Vue.extend(startScreenComponent);
  let instance = new constructor({
    el: document.createElement("div"),
  });
  document.body.appendChild(instance.$el);
  // 将单个 confirm instance 的配置合并到默认值中
  Object.assign(instance.$data, options);
  return new Promise((resolve, reject) => {
    instance.visible = true;
    let confirm = instance.startgame;
    let cancel = instance.exitgame;
    instance.startgame = () => {
      resolve("confirm");
      confirm();
    };
    instance.exitgame = () => {
      reject("cancel");
      cancel();
    };
  });
};

let hokConfirmScreen = (options = {}) => {
  let constructor = Vue.extend(confirmScreenComponent);
  let instance = new constructor({
    el: document.createElement("div"),
  });
  document.body.appendChild(instance.$el);
  // 将单个 confirm instance 的配置合并到默认值中
  Object.assign(instance.$data, options);
  return new Promise((resolve, reject) => {
    instance.visible = true;
    let confirm = instance.back;
    let cancel = instance.exitgame;
    instance.back = () => {
      resolve("confirm");
      confirm();
    };

    instance.exitgame = () => {
      reject("cancel");
      cancel();
    };
  });
};

const IFRAME = Vue.extend(defaultIframe);
const Profile = new IFRAME({
  el: document.createElement("div"),
});
document.body.appendChild(Profile.$el);
const IFRAME_METHOD = {
  open(options) {
    Profile.$data.visible = true;
    Profile.$data.needForceLandscape = options.needForceLandscape;
    Profile.$data.url = options.url;
    return;
  },
  hide() {
    Profile.$data.visible = false;
  },
};

let constructor = Vue.extend(loadingBoxComponent);
let instance = new constructor({
  el: document.createElement("div"),
});
document.body.appendChild(instance.$el);
// 将单个 confirm instance 的配置合并到默认值中
const loadingBox = {
  open() {
    instance.$data.visible = true;
  },
  hide() {
    instance.$data.visible = false;
  },
};

export default function (Vue) {
  // //添加全局API
  Vue.prototype.$dialogBox = dialogBox;
  Vue.prototype.$hokStartScreen = hokStartScreen;
  Vue.prototype.$hokConfirmScreen = hokConfirmScreen;
  Vue.prototype.$defaultIframe = IFRAME_METHOD;
  Vue.prototype.$loadingBox = loadingBox;
}
